export default function Cancel() {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" className="toast__icon">
			<g>
				<g>
					<circle cx="7.69995" cy="7.5" r="7" fill="white" />
				</g>
				<path d="M4.5 7.5H11" stroke="#404040" strokeWidth="1.5" strokeLinecap="round" />
			</g>
		</svg>
	);
}
